import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DesignLayout, CutterLayout, GalleryLayout, DriveLayout } from "./GuideMockups";
import "./UserGuide.css";

const SECTIONS = ["design", "cutter", "gallery", "drive"];
const LAYOUT_MAP = { design: DesignLayout, cutter: CutterLayout, gallery: GalleryLayout, drive: DriveLayout };

export default function UserGuidePage() {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("design");
  const [activeMarker, setActiveMarker] = useState(null);
  const LayoutComponent = LAYOUT_MAP[activeSection];

  // 폰에서 예시 화면(폭 640px)이 잘려 옆으로 밀어야 보였다 → 칸 폭에 맞춰 통째로 줄인다 (2026-10-19 김현비)
  useEffect(() => {
    // zoom 은 아이폰 Safari 에서 글자가 커지고 원이 잘려서 transform 으로 줄인다 (2026-10-19)
    const fit = () => {
      document.querySelectorAll(".guide-layout .guide-mockup").forEach((m) => {
        const box = m.parentElement;
        m.style.transform = "";
        m.style.marginBottom = "";
        const need = m.offsetWidth;
        const avail = box.clientWidth;
        if (need > avail + 1) {
          const k = avail / need;
          m.style.transformOrigin = "top left";
          m.style.transform = `scale(${k})`;
          // transform 은 자리 크기를 안 줄이므로 줄어든 높이만큼 아래 여백을 당겨 설명 목록이 붙게 한다
          m.style.marginBottom = `${-Math.round(m.offsetHeight * (1 - k))}px`;
        }
      });
    };
    fit();
    const t1 = setTimeout(fit, 300);
    window.addEventListener("resize", fit);
    return () => { clearTimeout(t1); window.removeEventListener("resize", fit); };
  }, [activeSection]);

  return (
    <div className="guide-page">
      <div className="guide-header">
        <h1>{t("guide.title")}</h1>
        <p className="guide-subtitle">{t("guide.subtitle")}</p>
      </div>
      <div className="guide-tabs">
        {SECTIONS.map((key) => (
          <button key={key} className={`guide-tab ${activeSection === key ? "active" : ""}`}
            onClick={() => { setActiveSection(key); setActiveMarker(null); }}>
            {t(`guide.${key}.tab`)}
          </button>
        ))}
      </div>
      <div className="guide-content">
        <h2 className="guide-section-title">{t(`guide.${activeSection}.title`)}</h2>
        <p className="guide-section-desc">{t(`guide.${activeSection}.desc`)}</p>
        <LayoutComponent activeMarker={activeMarker} setActiveMarker={setActiveMarker} t={t} />
      </div>
    </div>
  );
}
